import React from 'react';
import moment from 'moment';

import {Input} from '../../components/Input';
import {db, getCurrentUser} from '../../firebase';

const DROPOFF_FORM_FIELDS  = [
  {
    key: 'name',
    display: 'Name',
    required: true,
    type: 'text',
  },
  {
    key: 'radius',
    display: 'Radius',
    required: true,
    type: 'number',
  },
  {
    key: 'lat',
    display: 'Latitude',
    required: true,
    type: 'number',
  },
  {
    key: 'lng',
    display: 'Longitude',
    required: true,
    type: 'number',
  },
  {
    key: 'startedAt',
    display: 'Start Time',
    required: true,
    type: 'datetime-local',
  },
  {
    key: 'endedAt',
    display: 'End Time',
    required: true,
    type: 'datetime-local',
  },
  {
    key: 'capacity',
    display: 'Capacity',
    required: true,
    type: 'number',
  },
  {
    key: 'market',
    display: 'Market',
    required: true,
    type: 'text',
  },
]

class CreateDropoffForm extends React.Component {
  constructor(props) {
    super(props);

    this.initialState = {
      lat: 0,
      lng: 0,
      radius: 0,
      capacity: 0,
      startedAt: new Date(),
      endedAt: new Date(),
      name: '',
      repairZone: false,
      magicText: '',
      market: '',
    }

    this.state = this.initialState;
  }

  createDropoff = async (e) => {
    e.preventDefault();

    const {
      lat, lng, radius, capacity, startedAt, endedAt, name, repairZone, market
    } = this.state;

    const user = getCurrentUser()
    const {email, uid: userId} = user;

    await db.collection('streetTeamDropoffs/').add({
      lat: parseFloat(lat),
      lng: parseFloat(lng),
      radius: parseInt(radius, 10),
      capacity: parseInt(capacity, 10),
      initialCapacity: parseInt(capacity, 10),
      name,
      createdByUserEmail: email,
      createdByUserId: userId,
      createdAt: new Date(),
      startedAt: moment(startedAt).toDate(),
      endedAt: moment(endedAt).toDate(),
      repairZone: repairZone,
      market: market,
    })

    this.setState(this.initialState);
  }

  parseMagicText(magicText) {
    this.setState({magicText});
    const [
      name,
      radius,
      lat,
      lng,
      capacity,
      startText,
      endText,
      repairZoneString,
      market,
    ] = magicText.split(/\s+,\s+/); // Put hidden field with commas between fields

    const repairZone = repairZoneString === 'TRUE'
    const startedAt = moment(startText).format('YYYY-MM-DDTHH:mm');
    const endedAt = moment(endText).format('YYYY-MM-DDTHH:mm');

    this.setState({
      name, radius, lat, lng, capacity, startedAt, endedAt, repairZone
    })
  }

  render() {
    const {repairZone, magicText} = this.state;

    return (
      <div>
        <h4>Create Dropoff</h4>
        
        <label className='font-weight-bold'>
          <a
            href="https://docs.google.com/spreadsheets/d/1dEjIesP9HwFoHb7MNEbhsRMeUZhzT1VBuG2amqTxPD8"
            target="_blank"
          >
            Magic Field
          </a>
        </label>
        <input
          type='text'
          className='form-control'
          value={magicText}
          onChange={(e) => this.parseMagicText(e.target.value)}
        />

        <form onSubmit={this.createDropoff}>
          <div className="row">
            {DROPOFF_FORM_FIELDS.map((fieldInfo) => (
                <Input
                  updateValue={(new_value) => this.setState({[fieldInfo.key]: new_value})}
                  value={this.state[fieldInfo.key]}
                  fieldKey={fieldInfo.key}
                  {...fieldInfo}
                  />))}
          </div>

          <div class="col-6 my-2">
            <div className="form-check">
              <label className="form-check-label-bold">
                <input
                  type="checkbox"
                  checked={repairZone}
                  className="form-check-input"
                  onChange={() => this.setState({
                    repairZone: !repairZone,
                  })}
                /> Repair Zone?
              </label>
            </div>
          </div>
          
          <button className='btn btn-primary'>
            Create
          </button>
        </form>
      </div>
    );
  }
}

CreateDropoffForm.propTypes = {

};



class DropoffsDashboard extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isLoading: true,
      streetTeamDropoffs: null
    }
  }

  componentDidMount = () => {
    db
    .collection('streetTeamDropoffs')
    .orderBy('startedAt', 'desc')
    .onSnapshot((querySnapshot) => {
      this.setState({
        isLoading: false,
        streetTeamDropoffs: querySnapshot.docs,
      })
    });
  }

  deleteDropoff = async (dropoffId) => {
    if (window.confirm('Are you sure you wish to delete this dropoff?')) {
      await db
      .collection('streetTeamDropoffs')
      .doc(dropoffId)
      .delete()
    }
  }

  render() {
    const {streetTeamDropoffs, isLoading} = this.state;

    if (isLoading) {
      return (
        <div>
          Loading dropoffs...
        </div>
      )
    }

    return (
      <div className='container-fluid'>
        <div className='row'>
          <div className='col'>
            <h3>Dropoffs</h3>

            <CreateDropoffForm />

            <hr className='my-5' />

            <h4>Existing Dropoffs</h4>

            <div className='table-responsive'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Repair Zone?</th>
                    <th>Created At</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Initial Capacity</th>
                    <th>Current Capacity</th>
                    <th>Lat / Lng</th>
                    <th>Radius</th>
                    <th>Created By</th>
                  </tr>
                </thead>

                <tbody>
                  {streetTeamDropoffs.map((dropoff) => {
                    const {id: dropoffId} = dropoff;
                    const {
                      startedAt, endedAt, lat, lng, capacity, initialCapacity, radius, createdAt,
                      createdByUserEmail, name, repairZone
                    } = dropoff.data();

                    return (
                      <tr key={dropoffId}>
                        <td>{dropoffId}</td>
                        <td>{name}</td>
                        <td>{repairZone ? 'Yes' : 'No'}</td>
                        <td>{createdAt && moment(createdAt.toDate()).format()}</td>
                        <td>{startedAt && moment(startedAt.toDate()).format()}</td>
                        <td>{endedAt && moment(endedAt.toDate()).format()}</td>
                        <td>{initialCapacity}</td>
                        <td>{capacity}</td>
                        <td>{lat} {lng}</td>
                        <td>{radius}</td>
                        <td>{createdByUserEmail}</td>
                        <td style={{cursor: "pointer"}} onClick={() => this.deleteDropoff(dropoffId)}>X</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

DropoffsDashboard.propTypes = {

};

export {DropoffsDashboard};


// WEBPACK FOOTER //
// ./src/street-team/admin/DropoffsDashboard.js